import holidaysDe from '../config/national-holidays';
import {addDays, format, isSunday, isWeekend} from 'date-fns';

export function formatDate(_date: string | Date, dateFormat = 'yyyy-MM-dd') {
    return format(typeof _date === 'string' ? new Date(_date) : _date, dateFormat);
}

export function isHoliday(_date: string | Date) {
    const strDate = formatDate(_date);
    return holidaysDe.some(({date}) => strDate === date);
}

export function filterIsWeekdays(date: Date) {
    return !isWeekend(date) && !isSunday(date) && !isHoliday(date);
}

export function getMinAvailableDate(date: Date): Date {
    const tomorrow = addDays(date, 1);
    if (!filterIsWeekdays(tomorrow)) {
        return getMinAvailableDate(tomorrow);
    }

    return tomorrow;
};
